
import {
  ref,
  defineComponent,
  reactive,
  toRefs,
  getCurrentInstance,
  onMounted,
  watch
} from "vue";
import { getSearch } from "../views/api/user";
import router from "@/router";
import { useRouter, useRoute } from "vue-router";
export default defineComponent({
  setup() {
    //获取全局变量
    const type = reactive<any>(true);
    const proxy = getCurrentInstance() as any;
     let router1 = useRoute();
     let router2 = useRouter()
    console.log("proxy11", proxy);
 let search = reactive<any>(router1.params.inputValue);
 console.log("search",search.value)
    //全局url
    const url = proxy.appContext.config.globalProperties.$url;
    let show = ref<any>(true);
    //全局语言
    if (window.sessionStorage.getItem("language") as string) {
      var lan = JSON.parse(proxy.appContext.config.globalProperties.$language);
    }
    if (lan == "EN") {
      show.value = false;
    } else {
      show.value = true;
    }
    // chrome
      document.body.scrollTop = 0;
      // firefox
      document.documentElement.scrollTop = 0;
    let newsData = ref([]);

    //获取国际合作数据
    const getNews = async () => {
      if (lan == "EN") {
      let inputValue = reactive({
          search: search,
          IsEn:true,
        });
        const res = await getSearch.getData(inputValue);
        newsData.value = res.data.result;
        console.log("newsData", newsData);
      } else {
       let inputValue = reactive({
          search: search,
          IsEn:false,
        });
        const res = await getSearch.getData(inputValue);
        newsData.value = res.data.result;
        console.log("newsData", newsData);
      }
    };
watch(() =>router2.currentRoute.value.path,(newValue,oldValue)=> {
        console.log('watch',router2.currentRoute.value);
       search= router2.currentRoute.value.params.inputValue
         getNews()
},{ immediate: true })
    const goLink = (id, title) => {
      window.sessionStorage.setItem(
        "absorbData",
        JSON.stringify(newsData.value)
      );
      if (lan == "EN") {
        let name = reactive<any>("News");
        router.push({
          path: "/article/" + id + "/" + name + "/" + title + "/" + type,
        });
      } else {
        let name = reactive<any>("新闻");
        router.push({
          path: "/article/" + id + "/" + name + "/" + title + "/" + type,
        });
      }
    };

    onMounted(() => {
      getNews();
    });

    return {
      url,
      getNews,
      goLink,
      show,
      newsData,
      type,
    };
  },
});
